module.exports = __webpack_public_path__ + "static/img/QR4.07116388.jpg";